import { PureComponent } from 'react';

import { number, string } from '@philips-emr/tws-core/lib/component/prop-types';

export default class HpmsTabelaPrecoBase extends PureComponent {

  constructor(props) {
    super(props);
  }

  static propTypes = {
    nrSeqTabelaPreco: number,
    nmTabela: string,
    dtInicioVigencia: string,
  };

}
